import React from "react";
import { Container, Table } from "react-bootstrap";
import PropTypes from "prop-types";
import WorkOrderActiveWorkItemTransition from "./WorkOrderActiveWorkItemTransition";
import "./WorkOrderActiveWorkItemTransitions.css";

function WorkOrderActiveWorkItemTransitions({ transitions }) {
  if (
    transitions !== undefined &&
    transitions != null &&
    transitions.length > 0
  ) {
    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Process Order</th>
            <th>Transitioned By</th>
            <th>Transition</th>
            <th>Transitioned At</th>
          </tr>
        </thead>
        <tbody>
          {transitions.map((transition) => (
            <WorkOrderActiveWorkItemTransition
              key={transition.id}
              transition={transition}
            />
          ))}
        </tbody>
      </Table>
    );
  }
  return (
    <Container className="coreContent">
      <p>There are no transitions for this work item</p>
    </Container>
  );
}

WorkOrderActiveWorkItemTransitions.propTypes = {
  transitions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default WorkOrderActiveWorkItemTransitions;
